import { ISiteDetails } from "../models/Interfaces";

type ConnectedSiteAi = ISiteDetails & { AIEnabled: true; AIProvider: string; AIModel: string; AIApiKey: string };
type ImageConnectedSiteAi = ConnectedSiteAi & { AIAllowImageGeneration: true; AIImageModel: string };

const hasText = (value?: string | null): boolean => Boolean(value?.trim());

// OpenAI can use the default API host. Every other provider needs the endpoint saved in Site Details.
const endpointRequired = (provider?: string | null): boolean => (provider ?? "").trim().toLowerCase() !== "openai";

export const isSiteAiConnected = (site?: ISiteDetails | null): site is ConnectedSiteAi => {
  if (!site?.AIEnabled) {
    return false;
  }

  if (!hasText(site.AIProvider) || !hasText(site.AIModel) || !hasText(site.AIApiKey)) {
    return false;
  }

  if (endpointRequired(site.AIProvider) && !hasText(site.AIEndpoint)) {
    return false;
  }

  return true;
};

export const isSiteAiImageConnected = (site?: ISiteDetails | null): site is ImageConnectedSiteAi =>
  isSiteAiConnected(site) && Boolean(site?.AIAllowImageGeneration) && hasText(site?.AIImageModel);
